import React, { useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { Dialog, Page } from "@shared/components";
import { AppRoute } from "@app/models/AppRoute";

interface Props {
  resourceLabel: "document" | "video";
  redirectTo?: AppRoute;
}

const DeepLinkAccessDeniedPage: React.FC<Props> = ({ resourceLabel, redirectTo = AppRoute.Home }) => {
  const history = useHistory();

  const handleDialogClose = useCallback(
    ({ reason }: { reason: "backdropClick" | "escapeKeyDown" | "closeClick" | "historyChange" }) => {
      if (reason !== "historyChange") {
        history.push(redirectTo);
      }
    },
    [history, redirectTo]
  );

  return (
    <Page>
      <Dialog open onClose={handleDialogClose} title="Access Denied" maxWidth="sm" fullWidth>
        <Box minHeight={120} display="flex" alignItems="center" justifyContent="center">
          <Typography
            variant="bodySubhead3"
            style={{ textAlign: "center", width: "100%", display: "block", fontSize: "1.1rem" }}
          >
            You don&apos;t have access to this {resourceLabel}. To request access, please reach out to{" "}
            <a href="mailto:investor.services@carlyle.com">investor.services@carlyle.com</a>.
          </Typography>
        </Box>
      </Dialog>
    </Page>
  );
};

export default DeepLinkAccessDeniedPage;
